var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.cc)?_c('img',{staticClass:"famfamfam-flags",class:_vm.countryCode,attrs:{"src":require("../assets/pixel.png"),"alt":_vm.countryCode + ' flag'}}):_c('span',{staticClass:"empty-flag"})])}
var staticRenderFns = []

export { render, staticRenderFns }